module.exports = __webpack_public_path__ + "media/team/alexis-38ab7723.png";